import { service } from '../../helpers/http'

export default {
  actions: {
    ActionAlgorithmRulesIndex: ({ commit }, payload) => {
      const p = { ...(payload || {}) }

      // TablesDataTables envia `search`; backend espera `q`
      if (p.search != null && String(p.search).trim() !== '') {
        p.q = p.search
      }
      delete p.search
      delete p.column_order
      delete p.direction

      return service({
        module: 'algorithmRules',
        action: 'index',
        payload: p,
      })
    },

    ActionAlgorithmRulesDuplicate: ({ commit }, payload) =>
      service({
        module: 'algorithmRules',
        action: 'duplicate',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAlgorithmRulesToggle: ({ commit }, payload) => {
      const body = {}
      if (Object.prototype.hasOwnProperty.call(payload || {}, 'active')) {
        body.active = payload.active
      }

      return service({
        module: 'algorithmRules',
        action: 'toggle',
        params: { id: payload.id },
        payload: body,
      })
    },

    ActionAlgorithmRulesDestroy: ({ commit }, payload) =>
      service({
        module: 'algorithmRules',
        action: 'destroy',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAlgorithmRulesShow: ({ commit }, payload) =>
      service({
        module: 'algorithmRules',
        action: 'show',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAlgorithmRulesStore: ({ commit }, payload) =>
      service({
        module: 'algorithmRules',
        action: 'store',
        payload,
      }),

    ActionAlgorithmRulesUpdate: ({ commit }, payload) =>
      service({
        module: 'algorithmRules',
        action: 'update',
        params: { id: payload.id },
        payload,
      }),
  },
  namespaced: true,
}
